import { Component, Input } from "@angular/core";
import { ProductItemGroup } from "@domain/project/floorplan/product-item-group";
import { ChipComponent } from "@odx/angular/components/chip";
import { IconComponent } from "@odx/angular/components/icon";

@Component({
  selector: "app-group-number-chip",
  standalone: true,
  imports: [ChipComponent, IconComponent],
  templateUrl: "./group-id-chip.component.html",
})
export class GroupIdChipComponent {
  @Input() group!: ProductItemGroup;
}
